import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { LoginForm } from '../components/auth/LoginForm';
import { RegisterForm } from '../components/auth/RegisterForm';
import { GraduationCap } from 'lucide-react';

const Auth = () => {
  const [isLogin, setIsLogin] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Verificar e animar elementos da página
      const authFadeElements = containerRef.current?.querySelectorAll(".auth-fade-in")
      if (authFadeElements && authFadeElements.length > 0) {
        gsap.fromTo(
          authFadeElements,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
            ease: "power2.out",
          },
        );
      }

      // Verificar e animar fundo
      const bgGradientElements = containerRef.current?.querySelectorAll(".bg-gradient")
      if (bgGradientElements && bgGradientElements.length > 0) {
        gsap.fromTo(
          bgGradientElements,
          { opacity: 0 },
          {
            opacity: 1,
            duration: 1.2,
            ease: "power2.out",
          },
        );
      }
    }, containerRef);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    // Verificar e animar transição entre login e registro
    const formContainerElements = document.querySelectorAll(".form-container")
    if (formContainerElements && formContainerElements.length > 0) {
      gsap.fromTo(
        formContainerElements,
        { opacity: 0, x: isLogin ? -20 : 20 },
        {
          opacity: 1,
          x: 0,
          duration: 0.4,
          ease: "power2.out",
        },
      );
    }
  }, [isLogin]);

  return (
    <div 
      ref={containerRef}
      className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4"
    >
      {/* Background gradient overlay */}
      <div className="bg-gradient absolute inset-0 bg-gradient-to-br from-blue-900/20 via-purple-900/10 to-slate-900/30" />
      
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="auth-fade-in absolute -top-40 -right-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" />
        <div className="auth-fade-in absolute -bottom-40 -left-40 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-md">
        {/* Logo/Brand */}
        <div className="auth-fade-in text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full mb-4">
            <GraduationCap className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">
            EduTech
          </h1>
          <p className="text-slate-400">
            Plataforma de cursos online
          </p>
        </div>

        {/* Form Container */}
        <div className="form-container">
          {isLogin ? (
            <LoginForm onSwitchToRegister={() => setIsLogin(false)} />
          ) : (
            <RegisterForm onSwitchToLogin={() => setIsLogin(true)} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Auth; 